import { Roles } from '../../models/user.model';
import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user/user.service';
import { User } from '../../models/user.model';
import Swal from "sweetalert2";
import { TicketService } from 'src/app/services/ticket/ticket.service';

@Component({
  selector: 'app-staff-report',
  templateUrl: './staff-report.component.html',
  styleUrls: ['./staff-report.component.css']
})
export class StaffReportComponent implements OnInit {

  p = 1;
  Staff: User[];
  hideWhenNoStaff = false;
  noData = false;
  preLoader = true;
  searchValue = '';
  CountStatusAssigned: any[];
  CountStatusDraft: any[];
  CountStatusInformed: any[];
  CountStatusMoreInfo: any[];
  CountStatusAccepted: any[];
  CountStatusResolved: any[];
  CountStatusInProgress: any[];
  CountStatusClosed: any[];
  constructor(
    private user: UserService,
    private ticketService: TicketService,
  ) { }

  ngOnInit() {
    this.getStaffList();
    this.dataState();
  }

  private getStaffList() {
    this.user.getStaffsList().snapshotChanges().subscribe(data => {
      this.Staff = [];
      data.map(items => {
        const item = items.payload.doc.data();
        item['$uid'] = items.payload.doc['id'];
        this.Staff.push(item as User)
      })
      this.getCount(this.Staff);
    });
  }

  getCount(Staff) {
    console.log(Staff[0])
    this.CountStatusAccepted = [];
    this.CountStatusDraft = [];
    this.CountStatusInformed = [];
    this.CountStatusMoreInfo = [];
    this.CountStatusResolved = [];
    this.CountStatusAssigned = [];
    this.CountStatusInProgress = [];
    this.CountStatusClosed = []


    for (let i = 0;   i < Staff.length; i++){
     console.log(Staff);
      this.ticketService.getCountActionByUserIdStatus(Staff[i].fullName, 'Draft').subscribe(result => {
        this.CountStatusDraft[i] = result.length;
        // console.log(result.length);
       });
       this.ticketService.getCountActionByUserIdStatus(Staff[i].fullName, 'Informed').subscribe(result => {
        this.CountStatusInformed[i] = result.length;
        // console.log(result.length);
       });
       this.ticketService.getCountActionByUserIdStatus(Staff[i].fullName, 'More Info').subscribe(result => {
        this.CountStatusMoreInfo[i] = result.length;
        // console.log(result.length);
       });
       this.ticketService.getCountActionByUserIdStatus(Staff[i].fullName, 'In Progress',).subscribe(result => {
        this.CountStatusInProgress[i] = result.length;
        // console.log(result.length);
       });
       this.ticketService.getCountActionByUserIdStatus(Staff[i].fullName, 'Accepted').subscribe(result => {
        this.CountStatusAccepted[i] = result.length;
        // console.log(result.length);
       });
        this.ticketService.getCountActionByUserIdStatus(Staff[i].fullName, 'Assigned',).subscribe(result => {
         this.CountStatusAssigned[i] = result.length;
        //  console.log(result.length);
        });
        this.ticketService.getCountActionByUserIdStatus(Staff[i].fullName, 'Resolved',).subscribe(result => {
          this.CountStatusResolved[i] = result.length;
          // console.log(result.length);
         });
        this.ticketService.getCountActionByUserIdStatus(Staff[i].fullName, 'Closed').subscribe(result => {
          this.CountStatusClosed[i] = result.length;
          // console.log(result.length);
         });
      }
  
  }

  sumTotal(index: number) {
    return Number(this.CountStatusAccepted[index]) + Number(this.CountStatusAssigned[index]) + Number(this.CountStatusClosed[index]) + Number(this.CountStatusDraft[index]) + Number(this.CountStatusInProgress[index]) + Number(this.CountStatusInformed[index]) + Number(this.CountStatusMoreInfo[index]) + Number(this.CountStatusResolved[index])

  }

  dataState() {
    this.user.getStaffsList().snapshotChanges().subscribe(data => {
      this.preLoader = false;
      if (data.length <= 0) {
        this.hideWhenNoStaff = false;
        this.noData = true;
      } else {
        this.hideWhenNoStaff = true;
        this.noData = false;
      }
    });
  }

  dataStateSearch(keyword) {
    this.user.getUserByNameSort(keyword).snapshotChanges().subscribe(data => {
      this.preLoader = false;
      if (data.length <= 0) {
        this.hideWhenNoStaff = false;
        this.noData = true;
      } else {
        this.hideWhenNoStaff = true;
        this.noData = false;
      }
    });
  }

  getRoles(roles: Roles) {
    let Supporter
    let Maintenance
    let Supervisor
    let Developer
    if (roles.supporter === true) {
      Supporter = 'Supporter'
    } if (roles.maintenance === true) {
      Maintenance = 'Maintenance'
    } if (roles.supervisor === true) {
      Supervisor = 'Supervisor'
    } if (roles.developer === true) {
      Developer = 'Developer'
    }
    return [Supporter, Maintenance, Supervisor, Developer].filter((role): role is string => role !== undefined).join(", ");
  }

  search() {
    if (this.searchValue !== undefined && this.searchValue !== null && this.searchValue !== '') {
      this.getUserByNameSort(this.searchValue)
      this.dataStateSearch(this.searchValue)
    } else {
      this.getStaffList()
      this.dataState()
    }
  }

  getUserByNameSort(searchValue: string) {
    this.user.getUserByNameSort(searchValue).snapshotChanges().subscribe(data => {
      this.Staff = [];
      data.map(items => {
        const item = items.payload.doc.data();
        item['$uid'] = items.payload.doc['id'];
        this.Staff.push(item as User)
      })
    });
  }

  alertDeleteStaff(staff: User) {
    Swal.fire({
      title: 'Do you want to delete staff?',
      text: staff.name,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#2ED0B9',
      cancelButtonColor: '#9C9FA6',
      confirmButtonText: 'Yes, I do'
    }).then((result: { isConfirmed: any; }) => {
      if (result.isConfirmed) {
        this.user.deleteUserById(staff)
      }
    })
  }

}